import { ErrorHandler, Injectable } from '@angular/core';
import { KieneBackendApiService } from '../../../projects/kiene-core/src/lib/services/backend-api/kiene-backend-api.service';
import { PosthogService } from '../../../projects/kiene-core/src/lib/services/posthog/posthog.service';
import { environment } from '../../environments/environment';

@Injectable()
export class KieneErrorsHandler implements ErrorHandler {
    constructor(private api: KieneBackendApiService, private posthog: PosthogService) {}

    handleError(error: unknown): void {
        this.posthog.captureException(error);
        this.api.handleException(environment.production, this.toError(error));
    }

    private toError(error: unknown): Error {
        if (error instanceof Error) {
            return error;
        }
        if (error && typeof error === 'object') {
            const value = error as { name?: string; message?: string; status?: number; url?: string };
            const parts = [value.name, value.message, value.status, value.url].filter(
                part => part !== undefined && part !== null && String(part) !== '',
            );
            if (parts.length > 0) {
                return new Error(parts.join(' '));
            }
        }
        return new Error(String(error));
    }
}
